// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Tasks_pageContent__U_SYx"};